import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/SearchBar.css';

function Searchbar2() {
    const [query, setQuery] = useState('');
    const [searchHistory, setSearchHistory] = useState([]);
    const navigate = useNavigate();

    // Load search history from localStorage on component mount
    useEffect(() => {
        const storedHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
        setSearchHistory(storedHistory);
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        if (query.trim()) {
            // Remove duplicates and add to search history
            const newHistory = [query, ...searchHistory]
                .filter((value, index, self) => self.indexOf(value) === index) // Remove duplicates
                .slice(0, 5); // Limit to last 5 searches

            setSearchHistory(newHistory);
            localStorage.setItem('searchHistory', JSON.stringify(newHistory));

            navigate(`/catalog?search=${encodeURIComponent(query)}`);
        }
    };

    return (
        <div className="search-bar2">
            <form onSubmit={handleSearch}>
                <input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Search..."
                    aria-label="Search"
                    list="search-history" // Connect input to the datalist
                />
                <button type="submit"><i className="fas fa-magnifying-glass"></i></button>

                {/* Datalist for search history */}
                <datalist id="search-history">
                    {searchHistory.map((historyItem, index) => (
                        <option key={index} value={historyItem} />
                    ))}
                </datalist>
            </form>
        </div>
    );
}

export default Searchbar2;
